import { admin } from "./axios";
import { IPostLatestDatesResult } from "../../interface/IPostLatestDates";

export interface PostLatestDatesApiResponse {
  status: string;
  statusCode: number;
  message: string;
  data: IPostLatestDatesResult;
}

export const getPostLatestDates = async (): Promise<IPostLatestDatesResult> => {
  const response =
    await admin.get<PostLatestDatesApiResponse>("posts/latest-dates");

  return response.data.data;
};
